import { useState } from 'react';
import { SupplierThread } from '../components/forms/outreach/types';
import { outreachClient } from '../client/outreachClient';
import { apiErrorMessage } from '../utils/apiErrorMessage';

export type SpecDecisionChoice = 'ASK_FOR_OURS' | 'ACCEPT_THEIRS';

/**
 * Records the buyer's answer to "this supplier offers a different spec" on the
 * thread's supplier candidate, then refreshes the threads so the banner and
 * the next send both read the stored decision.
 */
export const useSpecDecision = (rfqId: string | undefined, onSaved: () => Promise<void> | void) => {
  const [isSavingSpecDecision, setIsSaving] = useState(false);
  const [specDecisionError, setError] = useState<string | null>(null);

  const decideSpec = async (thread: SupplierThread | undefined, decision: SpecDecisionChoice): Promise<boolean> => {
    if (!thread || isSavingSpecDecision) return false;
    if (!rfqId || !thread.componentId) {
      setError('I can’t find this supplier’s BOM line. Reload the page and try again.');
      return false;
    }
    setError(null);
    setIsSaving(true);
    try {
      await outreachClient.setSpecDecision(rfqId, thread.componentId, { supplierName: thread.supplierName, decision });
      await onSaved();
      return true;
    } catch (error) {
      setError(apiErrorMessage(error, 'I couldn’t save that. Try again.'));
      return false;
    } finally {
      setIsSaving(false);
    }
  };

  return { decideSpec, isSavingSpecDecision, specDecisionError };
};
